import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class ServicioToastService {

  constructor(public messageService: MessageService) { }

  addError(body: string, title ?: string) {
    this.messageService.add({ severity : 'error', detail : body, closable: true, summary : title || 'Error' });
  }
}
